import React, { useState, useEffect } from "react";
import styles from "../../../../styles/stylesgenerales";
import { Button, TextBox, ValidationGroup, Validator } from "devextreme-react";
import validacion from "../../../../helpers/validaciones";
import {
  RedirectToPantallaIntermediaMOCK,
  validacionIdentidadAction,
} from "../actions";
import { validarIdentidadUsuarioNoSerie } from "../../../../services/ValidacionIdentidad";

const ValidacionCuentaUsuario = ({ titulo, dispatch, email, phone }) => {
  const [rutValue, setRutValue] = useState("");
  const [isValidForm, setIsValidForm] = useState(false);
  return (
    <div
      className="acceso row"
      style={{ justifyContent: "center", alignItems: "center" }}
    >
      <div className="tituloLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div style={{ textAlign: "justify" }}>
          <h2
            className={"titulo-validacion-cuenta"}
            style={{ textAlign: "center", paddingTop: 20 }}
          >
            {titulo}
          </h2>
        </div>
      </div>
      <ValidationGroup className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div
          className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
          style={{ paddingBottom: 15 }}
        >
          <h4>
            <p className="text-left" style={{ marginTop: 11, fontSize: 15 }}>
              Rut{" "}
            </p>
          </h4>

          <TextBox
            placeholder="Ingresa tu Rut"
            valueChangeEvent="keyup"
            value={rutValue}
            onValueChanged={(e) => {
              setRutValue(
                e.value &&
                  validacion.formatRut(e.value, {
                    showHyphen: true,
                    showDots: false,
                  })
              );
              sessionStorage.setItem(
                "rutUsuarioActivacion",
                validacion.formatRut(e.value, {
                  showDots: false,
                  showHyphen: true,
                })
              );

              setIsValidForm(
                validacion.validateRut(
                  validacion.formatRut(e.value, {
                    showHyphen: true,
                    showDots: false,
                  })
                )
              );
            }}
          >
            <Validator
              validationRules={[
                { type: "required", message: "el rut es requerido" },
                {
                  type: "custom",
                  validationCallback: () => validacion.validateRut(rutValue),
                  message: "El rut es invalido",
                },
              ]}
            />
          </TextBox>
          <h4>
            <p className="text-left" style={{ marginTop: 11, fontSize: 12 }}>
              Sin puntos y con guión{" "}
            </p>
          </h4>
          {/* <span style={{ color: "red", marginTop: 10 }}>{error}</span> */}
        </div>

        <div
          className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
          style={{ textAlign: "center" }}
        >
          <Button
            disabled={!isValidForm}
            style={styles.fullWidth}
            text="Siguiente"
            type="default"
            //onClick={() => dispatch(RedirectToPantallaIntermediaMOCK())}
            onClick={() =>
              dispatch(
                validacionIdentidadAction(null, validarIdentidadUsuarioNoSerie)
              )
            }
          />
        </div>
      </ValidationGroup>
    </div>
  );
};

export default ValidacionCuentaUsuario;
